import { PromotionTemplate } from "../api/promotions.api";

export enum PromotionAspect {
  Small = "4:3",
  Large = "2.60:1"
}

// based on template, return size in pixels
export const getPromotionImageSize = (template: PromotionTemplate): {height: number, width: number, error?: string } => {
  switch (template) {
    // large hard coded to 2.60:1
    case PromotionTemplate.Large: {
      return {
        height: 250,
        width: 650
      };
    }
    // small hard coded to 4:3
    case PromotionTemplate.Small: {
      return {
        height: 250,
        width: 333
      };
    }
    default: {
      return {
        height: 0,
        width: 0,
        error: "Unhandled template type"
      };
    }
  }
};